import { AllTag } from "./AllTag";
import { GoalTag } from "./GoalTag";
import { LTOnReport } from "./LTOnReport";
import { LTPlayerScored } from "./LTPlayerScored";
import { LTPlayerStat } from "./LTPlayerStat";
import { LTRedCard } from "./LTRedCard";
import { Name } from "./Name";
import { NameTag } from "./NameTag";
import { OtherTag } from "./OtherTag";
import { Potm } from "./POTM";
import { FormationSOF } from "./FormationSOF";
import { FFStats } from "./FFStats";
import { FFScore } from "./FFScore";
import { Versus } from "./Versus";
import { TeamBottomBar } from "./TeamBottomBar";
import { TopPerformers } from "./TopPerformers";
import { Clock } from "./Clock";
import { Formation } from "./Formation";
import { OnBench } from "./OnBench";
import { MatchStats } from "./MatchStats";
import { PositionMatchStats } from "./PositionMatchStats";
import { EdgeMatchStats } from "./EdgeMatchStats";
import { SOFTable } from "./SOFTable";
import { CBTable } from "./CBTable";
import { GameScoresBug } from "./GameScoresBug";
import { LTScore } from "./LTScore";
import { CBSinBin } from "./CBSinBin";
import { PlayerCB } from "./PlayerCB";
import { VoiceOf } from "./VoiceOf";
import { GuestName } from "./GuestName";
import { CarryingStats } from "./CarryingStats";
import { AttackingStats } from "./AttackingStats";
import { DefendingStats } from "./DefendingStats";
import { CBSeasonStats } from "./CBSeasonStats";
import { CBChallenges } from "./CBChallenges";
import { CBChallengesComparison } from "./CBChallengesComparison";
import { CustomMatchStats } from "./CustomMatchStats";
import { CBManual } from "./CBManual";
import { FFTable } from "./FFTable";
import { LatestScoresCB } from "./LatestScoresCB";
import { GameScoresTag } from "./GameScoresTag";
import { LTSinBin } from "./LTSinBin";
import { TeamCrawl } from "./TeamCrawl";
import { KickPredictorGauge } from "./KickPredictorGauge";
import { Substitution } from "./Substitution";
import { TwoSubstitution } from "./TwoSubstitution";
import { ThreeSubstitution } from "./ThreeSubstitution";
import { ClockPlayerStat } from "./ClockPlayerStat";
import { ClockRedCard } from "./ClockRedCard";
import { ClockSinBin } from "./ClockSinBin";
import { WinPredictor } from "./WinPredictor";
import { ClockTeamStat } from "./ClockTeamStat";
import { ClockHIA } from "./ClockHIA";
import { ScoreBug } from "./ScoreBug";
import { HeroFormation } from "./HeroFormation";
import { Attendance } from "./Attendance";
import { KickMap } from "./KickMap";

export default function graphics({
  takeVizPage: animate,
  update,
  takeOutVizPage: animateOff,
  triggerAnimation,
  clearPreview,
  previewTrio: preview,
  getVizPage,
  updateVizPage,
  vizSharedMemory,
  vizCommand,
  createPage,
  setPageSummary,
  continueVizPage,
}) {
  return [
    new Name({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Clock({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      vizCommand,
    }),
    new Potm({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new LTSinBin({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new ClockTeamStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new LTRedCard({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new LTOnReport({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new LTPlayerScored({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new LTPlayerStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Substitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TwoSubstitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new ThreeSubstitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new ClockPlayerStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FormationSOF({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FFStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FFScore({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Versus({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Formation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TeamCrawl({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TeamBottomBar({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TopPerformers({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new OnBench({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new MatchStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new PositionMatchStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new EdgeMatchStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new GoalTag({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new OtherTag({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new GameScoresTag({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new NameTag({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new LatestScoresCB({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new FFTable({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new SOFTable({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new CBTable({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new GameScoresBug({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
    }),
    new LTScore({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    // new ClockTryTimeline({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    // }),
    new CBSinBin({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),

    new PlayerCB({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),

    new AllTag({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),

    new VoiceOf({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new GuestName({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    // new FFStatsLoggers({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    // }),
    new CarryingStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new AttackingStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new DefendingStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new KickPredictorGauge({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    // new PlayerKeyStats({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    // }),
    // new CBSeasonStats({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    // }),
    new CBManual({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new CBChallenges({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new CBChallengesComparison({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
    }),
    new HeroFormation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    // new ShotClock({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    //   continueVizPage,
    // }),
    new CustomMatchStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    new ClockRedCard({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    new ClockSinBin({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    new WinPredictor({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    new ScoreBug({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    new Attendance({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
        new KickMap({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
         new ClockHIA({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      createPage,
      setPageSummary,
      vizCommand,
      continueVizPage,
    }),
    // new Catapult({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    //   continueVizPage,
    // }),
    // new CatapultPlayerCB({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    //   continueVizPage,
    // }),
    // new CatapultLTPlayerStat({
    //   preview,
    //   animate,
    //   update,
    //   animateOff,
    //   triggerAnimation,
    //   getVizPage,
    //   updateVizPage,
    //   vizSharedMemory,
    //   createPage,
    //   setPageSummary,
    //   vizCommand,
    //   continueVizPage,
    // }),
  ];
}
